import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Radio,
  Tab,
  withStyles,
  Typography,
  Divider,
  TextField,
} from '@material-ui/core'
import { ReactComponent as SearchIcon } from './Search.svg'
import { ReactComponent as CalendarIcon } from './Calendar.svg'
import styled from 'styled-components'
import { Container, Tabs } from 'sputnik-ui'
import PartnerProgramAnalytics from 'components/organisms/Analytics/PartnerProgramAnalytics/index.js'
import LicensedKeysAnalytics from 'components/organisms/Analytics/LicensedKeysAnalytics/index.js'
import { useTranslation } from 'react-i18next'
import { fetchLocalities, setLocalityFilter } from 'features/Devices/localitiesSlice'

const BlueRadio = withStyles({
  root: {
    '&$checked': {
      color: '#2C98F0',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)

const Content = styled.div`
  margin-left: 8rem;
  display: flex;
  flex-direction: column;
  margin-right: 8rem;
  @media (max-width: 1000px) {
    margin-left: 0rem;
  }
`

const ResDiv = styled.div`
  display: flex;
`

function StartEndDatesComponent({ handleChangeStartDate, handleChangeEndDate, values, minDate, style }) {
  const { t } = useTranslation(['analytics'])

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginTop: 11,
        ...style
      }}
    >
      <div>
        <Typography
          style={{
            padding: '0 5px 6px  ',
            lineHeight: '20.3667px',
          }}
        >
          {t('analytics:from')}
        </Typography>

        <Divider
          style={{
            width: 40,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          }} //need fix
        />
      </div>

      <TextField
        id="date"
        type="date"
        inputProps={{
          min: minDate,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        style={{
          marginTop: '.325rem',
        }}
        name="start_date"
        onChange={handleChangeStartDate}
        value={values.start_date}
      />
      <Divider
        style={{
          width: 30,
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
        }} //need fix
      />
      <div>
        <Typography
          style={{
            padding: '0 5px 6px  ',
            marginLeft: 'auto',
            lineHeight: '20.3667px',
          }}
        >
          -
        </Typography>

        <Divider
          style={{
            width: 30,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          }} //need fix
        />
      </div>
      <div>
        <Typography
          style={{
            padding: '0 5px 6px  ',
            lineHeight: '20.3667px',
          }}
        >
          {t('analytics:to')}
        </Typography>

        <Divider
          style={{
            width: 40,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          }} //need fix
        />
      </div>
      <TextField
        type="date"
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: minDate,
        }}
        style={{
          marginTop: '.325rem',
        }}
        name="end_date"
        onChange={handleChangeEndDate}
        value={values.end_date}
      />
    </div>
  )
}
function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

export default function AnalyticsPage({ ...props }) {
  const dispatch = useDispatch()
  const selectedCompanyUuid = useSelector(({ companies }) => companies.selected?.value)

  useEffect(() => {
    dispatch(fetchLocalities({company_uuid: selectedCompanyUuid}))
  }, [dispatch])
  const localities = useSelector(({ localities }) => localities.list)
  const localityFilter = useSelector(({ localities }) => localities.filter)
  const [currentTab, setCurrentTab] = useState('partnerProgram')
  const { t } = useTranslation(['analytics'])
  const tabs = [
    {
      label: t('analytics:tabs.partner_program'),
      value: 'partnerProgram'
    },
    {
      label:  t('analytics:tabs.licensed_keys'),
      value: 'licensedKeys'
    }
  ]

  return (
    <Container  style={{ marginTop: '1rem' }}>
      <Tabs onChange={(e, tab) => setCurrentTab(tab)} value={currentTab}>
        {tabs.map((tab) => (
          <Tab
            disableRipple
            label={tab.label}
            value={tab.value}
            key={tab.value}
          />
        ))}
      </Tabs>
      {currentTab === 'licensedKeys' && (
        <LicensedKeysAnalytics 
          formatDate={formatDate}
          BlueRadio={BlueRadio}
          ResDiv={ResDiv}
          Content={Content}
          Container={Container}
          StartEndDatesComponent={StartEndDatesComponent}
          setLocalityFilter={setLocalityFilter}
          localities={localities}
          localityFilter={localityFilter}
          selectedCompanyUuid={selectedCompanyUuid}
        />
      )}
      {currentTab === 'partnerProgram' && (
        <PartnerProgramAnalytics
          formatDate={formatDate}
          BlueRadio={BlueRadio}
          ResDiv={ResDiv}
          Content={Content}
          SearchIcon={SearchIcon}
          CalendarIcon={CalendarIcon}
          StartEndDatesComponent={StartEndDatesComponent}
          fetchLocalities={fetchLocalities}
          setLocalityFilter={setLocalityFilter}
          localities={localities}
          localityFilter={localityFilter}
          selectedCompanyUuid={selectedCompanyUuid}
         />
      )}
      
    </Container>
  )
}
